import { useLinkProps } from '@react-navigation/native';
import type { FC } from 'react';
import { View } from 'react-native';

import type { ListItemProps } from '@/features/list/components/ListItem';
import { ListItem } from '@/features/list/components/ListItem';
import type {
  NavigationItemProps,
  AppRoute
} from '@/navigation/types/navigation';

// See: https://reactnavigation.org/docs/link

type Props = NavigationItemProps & Omit<ListItemProps, 'onPress'>;

export const NavigationListItem: FC<Props> = ({
  screen,
  params,
  action,
  href,
  ...rest
}) => {
  const linkProps = useLinkProps<AppRoute>({
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    screen,
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    params,
    action,
    href
  });

  return (
    <View {...linkProps}>
      <ListItem {...rest} onPress={linkProps.onPress} />
    </View>
  );
};
